// Scroll-triggered reveal animations using IntersectionObserver
const revealElements = document.querySelectorAll('.reveal, .reveal-stagger, .reveal-fade')

if (revealElements.length > 0) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible')
          observer.unobserve(entry.target)
        }
      })
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px',
    }
  )

  revealElements.forEach((el) => observer.observe(el))
}
